export const QUESTION_BANK_ROUTES = {
  list: '/question-bank',
  practice: '/question-bank/practice',
  filter: '/question-bank/filter',
};
